<template>
    <v-container>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Kalendarz zjazdów</v-toolbar-title>
                <SelectMonths></SelectMonths>
                <v-divider
                        class="mx-4"
                        inset
                        vertical
                ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-dialog v-if="dialog" v-model="dialog" max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <v-row>
                                        <v-col cols="12">
                                            <AvailablePlacesSelect @placeChanged="changePlace" :place="editedItem.pid" :placeErrors="placeErrors" />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field v-model="editedItem.name" :error-messages="nameErrors" required  @blur="$v.editedItem.name.$touch()" label="Nazwa (opcjonalnie)"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field v-model="editedItem.comment" label="Uwagi"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-date-picker v-model="editedItem.dates" first-day-of-week="1" :allowed-dates="allowedDates" range></v-date-picker>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="pa-7">
                        <v-btn color="grey" class="overline" text @click="close"><v-icon small left>arrow_back</v-icon> <span v-if="$vuetify.breakpoint.mdAndUp">wroc do kalendarza</span></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="primary" rounded @click="close">Zamknij</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-row class="fill-height ma-4">
                <v-col>
                    <v-sheet>
                        <p v-if="!monthSelected">
                            ...still loading...
                        </p>
                        <div v-else>
                            <v-calendar
                                    ref="calendar"
                                    v-model="focus"
                                    color="primary"
                                    :events="meetings"
                                    :event-color="getEventColor"
                                    :now="today"
                                    :type="type"
                                    :weekdays="weekdays"
                                    @change="updateRange"
                                    @click:event="showEvent"
                                    @click:date="openNewWithStartSelected"
                                    :start="initDate()"
                            ></v-calendar>
                        </div>
                        <v-menu
                                v-model="selectedOpen"
                                :close-on-content-click="false"
                                :activator="selectedElement"
                                offset-x
                        >
                            <v-card
                                    color="grey lighten-4"
                                    min-width="350px"
                                    flat
                            >
                                <v-toolbar
                                        :color="selectedEvent.color"
                                        dark
                                >
                                    <v-toolbar-title v-html="selectedEvent.name + ' (' + this.placeNameById(selectedEvent.pid) + ')'"></v-toolbar-title>
                                </v-toolbar>
                                <v-card-text>
                                    {{ selectedEvent.comment }}
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn color="grey" class="overline" text @click="selectedOpen = false"><v-icon small left>arrow_back</v-icon>Powrot</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" rounded small @click="remove">Usuń</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>
                    </v-sheet>
                </v-col>
            </v-row>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="mt-4 mb-4 mr-4">
                    <v-row>
                        <v-col class="d-flex justify-end" md="12">
                            <v-btn @click="generatePDFReport()" color="primary" dark rounded small>Generuj raport</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import AvailablePlacesSelect from "../components/AvailablePlacesSelect";
import moment from "moment";
import SelectMonths from "./SelectMonths";

export default {
    mixins: [validationMixin],
    validations: {
      editedItem: {
        dates: {required},
        name: {required},
        pid: {required},
      }
    },
    components: {SelectMonths, AvailablePlacesSelect },
    name: 'AdminCalendar',
    data: () => ({
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Miesiąc',
        week: 'Tydzien'
      },
      start: null,
      end: null,
      today: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      editedIndex: -1,
      editedItem: {
        name: 'Zjazd',
        dates: [],
        pid: '',
        comment: ''
      },
      defaultItem: {
        name: 'Zjazd',
        dates: [],
        pid: '',
        comment: ''
      },
      menuDate: false,
    }),
    beforeCreate() {
      this.$store.dispatch('places/getPlaces')
    },
    computed: {
      ...mapGetters({
        meetings: 'meetings/getMeetings',
        meetingsReport: 'meetings/getMeetingsReport',
        dialogFromStore: 'meetings/dialogNew',
        placeNameById: 'places/getPlaceNameById',
        monthSelected: 'monthSelected',
      }),
      nameErrors () {
        const errors = [];
        if (!this.$v.editedItem.name.$dirty) return errors;
        !this.$v.editedItem.name.required && errors.push('Podanie nazwy jest konieczne');
        return errors
      },
      placeErrors () {
        const errors = [];
        if (!this.$v.editedItem.pid.$dirty) return errors;
        !this.$v.editedItem.pid.required && errors.push('Podanie miasta jest konieczne');
        return errors
      },
      dialog: {
        get(){
          return this.dialogFromStore
        },
        set(value){
          return this.setDialogNew(value)
        }
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Dodawanie nowego czasu pracy' : 'Edytuj czas pracy'
      },
      title () {
        const { start, end } = this;
        if (!start || !end) {
          return ''
        }

        const startMonth = this.monthFormatter(start);
        const endMonth = this.monthFormatter(end);
        const suffixMonth = startMonth === endMonth ? '' : endMonth;

        const startYear = start.year;
        const endYear = end.year;
        const suffixYear = startYear === endYear ? '' : endYear;

        const startDay = start.day + this.nth(start.day);
        const endDay = end.day + this.nth(end.day);

        switch (this.type) {
          case 'month':
            return `${startMonth} ${startYear}`;
          case 'week':
            return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
        }
        return ''
      },
      monthFormatter () {
        return this.$refs.calendar.getFormatter({
          timeZone: 'UTC', month: 'long',
        })
      },
      showSendForAcceptance () {
        if (this.meetings.length > 0 && this.meetingsReport == 0 && (this.userRole == 0 || this.userRole == 5)) {
          return true
        } else {
          return false
        }
      },
      showGenerateReport () {
        if (this.meetings.length > 0 && (this.meetingsReport > 0 || this.userRole == 1)) {
          return true
        } else {
          return false
        }
      },
      addingPossible () {
        if (this.meetingsReport == 0 || this.userRole == 1) {
          return true
        } else {
          return false
        }
      },
      currentMonthReadable () {
        return moment(this.monthSelected).format('MMMM YYYY')
      }
    },
    created() {
      this.$store.dispatch('meetings/getMeetings', { 'start': moment(this.monthSelected).startOf('month').format('YYYY-MM-DD'), 'end': moment(this.monthSelected).endOf('month').format('YYYY-MM-DD')});

      this.unwatchMonth = this.$store.watch(
        (state, getters) => getters.monthSelected,
        (newValue) => {
          this.$store.dispatch(
            'meetings/getMeetings',
            {
              'start': moment(newValue).startOf('month').format('YYYY-MM-DD'),
              'end': moment(newValue).endOf('month').format('YYYY-MM-DD') }
          );
        },
      );
    },
    beforeDestroy() {
      this.unwatchMonth();
    },
    methods: {
      ...mapActions({
        setDialogNew: 'meetings/setDialogNew',
        createMeeting: 'meetings/createMeeting',
        editMeeting: 'meetings/editMeeting',
        deleteMeeting: 'meetings/deleteMeeting',
        setMonthSelected: 'setMonthSelected',
        createReport: 'meetings/createReport',
      }),
      initDate () {
        return moment(this.monthSelected).startOf('month').format('YYYY-MM-DD')
      },
      editItem () {
        this.editedIndex = this.meetings.map(function(e) { return e.id }).indexOf(this.selectedEvent.id)
        this.editedItem = Object.assign({}, this.selectedEvent)
        this.editedItem.dates = [this.selectedEvent.start, this.selectedEvent.end]
        this.dialog = true
      },
      close () {
        this.dialog = false;
      },
      getEventColor (event) {
        return event.color
      },
      remove () {
        if(confirm('Czy na pewno chcesz usunąć poniższy termin?')){
          this.deleteMeeting(this.selectedEvent.id).then( () => {
            this.$log.info('Deleted meeting ' + this.selectedEvent.id);
            this.selectedOpen = false
          }).catch(error => {
            this.$log.error('Deleting meeting error', error)
          })
        }
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event;
          this.selectedElement = nativeEvent.target;
          setTimeout(() => this.selectedOpen = true, 10)
        };

        if (this.selectedOpen) {
          this.selectedOpen = false;
          setTimeout(open, 10)
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      openNewWithStartSelected ({ date }) {
        if (this.allowedDates(date)) {
          this.editedItem.dates[0] = date;
          this.dialog = true
        }
      },
      formatDate (a, withTime) {
        return withTime
          ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
          : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`
      },
      updateRange ({ start, end }) {
        this.start = start;
        this.end = end
      },
      nth (d) {
        return d > 3 && d < 21
          ? 'th'
          : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
      },
      allowedDates: val => ![1, 2, 3, 4].includes(new Date(val).getDay()),
      changePlace (value) {
        this.editedItem.pid = value
      },
      generatePDFReport () {
        var table = [];
        table.push(["Od", "Do", "Miasto", "Uwagi", "Wykładowca"]);

        function passItem() {
          return function (obj) {
            return [new Date(obj.start).toISOString().substr(0, 10), new Date(obj.end).toISOString().substr(0, 10), obj.cityName, obj.comment, obj.name]
          }
        }
        var body = table.concat(this.meetings.map(passItem()));

        var pdfMake = require('pdfmake/build/pdfmake.js');
        if (pdfMake.vfs == undefined){
          var pdfFonts = require('pdfmake/build/vfs_fonts.js');
          pdfMake.vfs = pdfFonts.pdfMake.vfs;
        }
        var docDefinition = {
          content: [
            {
              stack: [
                'Zjazdy za miesiąc ' + this.monthSelected.substr(0, 7),
              ],
              style: 'header'
            },
            {
              style: 'tableExample',
              table: {
                body: body
              }
            }
          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              margin: [0, 0, 0, 80],
              alignment: "center"
            }
          }
        };
        pdfMake.createPdf(docDefinition).download('unikadra-report-'+this.monthSelected+'.pdf')
      }

    },
  }
</script>

<style scoped>

</style>
